import React from "react";
import { ArrowRight, TrendingUp, Activity, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { Area, AreaChart, CartesianGrid, XAxis } from "recharts";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const chartData = [{
  month: "Jan",
  value: 100
}, {
  month: "Feb",
  value: 120
}, {
  month: "Mar",
  value: 115
}, {
  month: "Apr",
  value: 160
}, {
  month: "May",
  value: 150
}, {
  month: "Jun",
  value: 210
}];
const chartConfig = {
  value: {
    label: "Recovery Value",
    color: "var(--chart-1)"
  }
};
export default function RecoverValueFromSpentCoCatalyst() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="recover-value-from-spent-co-catalyst" className="dark bg-background text-foreground font-mono relative overflow-hidden py-16 lg:py-24">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-ring/5 via-background to-background opacity-50" />
      </div>

      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-8 items-center">
          {}
          <div ref={ref} className={`lg:col-span-7 flex flex-col gap-8 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-4">
              <h1 className="text-4xl font-bold tracking-tight leading-[1.1] !font-sans sm:text-5xl lg:text-6xl">Recover Value from <br />Spent CO Catalyst</h1>
              
              <div className="space-y-2">
                <h2 className="text-2xl font-medium bg-gradient-to-r from-foreground via-muted-foreground to-muted-foreground/50 bg-clip-text text-transparent !font-sans sm:text-3xl">Turn disposal costs into measurable returns.</h2>
                <p className="text-lg text-muted-foreground max-w-2xl leading-relaxed !font-sans">Catalyst Resource Group, LLC works with industrial facilities to safely, efficiently, and profitably recover valuable metals from spent CO catalyst.</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <Button asChild size="lg" className="bg-ring text-background hover:bg-ring/90 shadow-lg shadow-ring/20 rounded-none font-bold">
                <Link to="#contact" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive h-10 px-6 has-[>svg]:px-4 bg-ring text-background shadow-lg shadow-ring/20 rounded-none font-bold !font-sans disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-ring/90">Request a CO Catalyst Evaluation</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-ring/50 text-ring hover:bg-ring/10 hover:text-ring hover:border-ring rounded-none font-bold">
                
              </Button>
            </div>

            {}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 pt-8 border-t border-border/30">
              <div className="flex items-center gap-3">
                <ShieldCheck className="h-5 w-5 text-ring" />
                <span className="text-sm font-medium !font-serif">Safe & Compliant</span>
              </div>
              <div className="flex items-center gap-3">
                <TrendingUp className="h-5 w-5 text-ring" />
                <span className="text-sm font-medium !font-serif">Maximized Returns</span>
              </div>
              <div className="flex items-center gap-3">
                <Activity className="h-5 w-5 text-ring" />
                <span className="text-sm font-medium !font-serif">Transparent Process</span>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative h-[500px] lg:h-[600px] w-full hidden lg:block">
            {}
            <div className="absolute top-0 right-0 w-[90%] h-[85%] rounded-none overflow-hidden shadow-2xl border border-border/20">
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent z-10 !bg-[url(https://catalystresourcegroupllc.com/wp-content/uploads/2026/03/crghero.png)] !bg-[url(https://catalystresourcegroupllc.com/wp-content/uploads/2026/03/crgheroopt.png)]" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1567261/img/refinery_twilight.png" alt="Modern refinery at twilight" className="w-full h-full object-cover" />
            </div>

            {}
            <div className="absolute bottom-8 left-0 w-[65%] z-20 animate-in fade-in slide-in-from-bottom-8 duration-1000 delay-300 fill-mode-forwards">
              
            </div>
          </div>
          
          {}
          <div className="lg:hidden relative h-[300px] w-full rounded-none overflow-hidden mt-8">
             <img src="https://catalystresourcegroupllc.com/wp-content/uploads/2026/03/crgheroopt.png" alt="Modern refinery at twilight" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
          </div>
        </div>
      </div>
    </section>;
}